class APIS {
	apis() {
		return {
			locCheck: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/client/credit-line/check-eligibility'
			},
			attachCreditLine: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/client/credit-line/attach'
			},
			CreditLineRevoke: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/client/credit-line/revoke'
			},
			updateAllocationId: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/client/credit-line/update-allocation'
			},
			createRmUser: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/create/rm/user'
			},
			attachCreditLineRoute: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/attach/credit/line'
			}
		};
	}
}

export default new APIS();
